import moment from "moment";

export const parametersData = [
  { id: 1, name: "assets-liabilities" },
  { id: 2, name: "profit-loss" },
  { id: 3, name: "opening-balance" },
  { id: 4, name: "previous-balance" },
  { id: 5, name: "exclude-cash-transactions" },
  // { id: 6, name: "جميع العمليات النقدية" },
];

export const defaultParams = {
  dateFrom: moment(new Date()).format("YYYY-MM-DD"),
  dateTo: moment(new Date()).format("YYYY-MM-DD"),
  // orderType: sortTypes[0],
  docType: { id: -1, name: "" },
  branch: { id: -1, name: "all" },
  accounts: [],
  omla: { id: -1, name: "" },
  parameters: [...parametersData],
};

export function getLeafAccounts(data) {
  var res = [];
  for (let account of data) {
    if (account.Type === 1) {
      if (account.hasOwnProperty("children")) {
        var res1 = getLeafAccounts(account.children);
        res.push(res1);
      }
    } else if (account.Type === 2) {
      res.push(account);
    }
  }
  return res;
}
